import React from 'react';
import { Link } from 'react-router-dom';
import './WeddingInfo.css';

const WeddingInfo: React.FC = () => {
  return (
    <div className="info-container">
      <div className="info-card">
        <h1 className="info-title">Informations sur le mariage</h1>
        <div className="info-section">
          <h2 className="section-title">📅 Date et heure</h2>
          <p className="info-text">Samedi 3 octobre 2026</p>
          <p className="info-text">Arrivée à 14h30</p>
          <p className="info-text">Cérémonie à 15h</p>
        </div>

        <div className="info-section">
          <h2 className="section-title">📍 Lieu</h2>
          <p className="info-text">Cabane à sucre chez Ti-Père</p>
          <a
            href="https://maps.app.goo.gl/fk3C2R2DrE5jFEAPA"
            target="_blank"
            rel="noopener noreferrer"
            className="map-link">
            Voir sur la carte
          </a>
        </div>

        <div className="info-section">
          <h2 className="section-title">👫 Invités</h2>
          <p className="info-text">Il s'agit d'un moment privilégié entre adultes.</p>
        </div>

        <div className="info-section">
          <h2 className="section-title">💰 Coût</h2>
          <p className="info-text">Une contribution de <strong>85$</strong> par personne est demandée.</p>
          <p className="info-text">Vous pouvez effectuer le paiement par virement Interac au compte courriel suivant : <strong>ml@ja-dev.com</strong></p>
        </div>

        <div className="info-section">
          <h2 className="section-title">🎁 Cadeau</h2>
          <p className="info-text">Votre présence est le plus beau des cadeaux !</p>
          <p className="info-text">Après 17 années de vie commune, dont 9 en tant que fianciés, nous avons déjà tout ce dont nous avons besoin. Nous vous suggérons donc d'apporter des denrées non-périssables qui seront ensuite ramassées sur place par un organisme local.</p>
        </div>

        <div className="info-section">
          <h2 className="section-title">ℹ️ Informations supplémentaires</h2>
          <ul className="info-list">
            <li>La cérémonie et la réception auront lieu au même endroit. La cérémonie aura lieu à l'extérieur si la température le permet, à l'intérieur sinon.</li>
            <li>La réception se terminera à <strong>minuit</strong></li>
            <li>Un vaste stationnement est disponible sur place. Il est possible d'y stationner un VR pour ceux qui désirent y passer la nuit.</li>
          </ul>
        </div>

        <div className="info-section">
          <h2 className="section-title">✉️ RSVP</h2>
          <p className="info-text">Nous avons hâte de célébrer avec vous ! ❤️ 💐 🎉</p>
          <p className="info-text">Merci de remplir le formulaire de confirmation avant le 15 juillet 2026 que vous puissiez être présents ou non.</p>
          <div className="rsvp-link-wrapper">
            <Link to="/dashboard" className="rsvp-link">Confirmer ma présence (RSVP)</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeddingInfo;
